

class magnifyJS {
  constructor() {
    this.zoomRatio = 1; // Default zoom ratio
    this.maxZoomRatio = 5; // Maximum allowed zoom ratio
    this.isDragging = false; // Track dragging state
    this.isPinching = false; // Track pinch state
    this.startX = 0; // Starting X position for touch
    this.startY = 0; // Starting Y position for touch
    this.translateX = 0; // Current X translation
    this.translateY = 0; // Current Y translation
    this.initialPinchDistance = 0; // Initial pinch distance
    this.lastPinchZoom = 1; // Last pinch zoom ratio
    this.activeImage = null; // Reference to the currently zoomed image

    if (window.innerWidth < 768) {
      this.setupZoomControls();
      this.enableZoomOnTouch();
    }
  }

  setupZoomControls() {
    const zoomPlusBtns = document.querySelectorAll('.zoom-plus');
    const zoomMinusBtns = document.querySelectorAll('.zoom-minus');
    // Add event listeners for zoom-left and zoom-right buttons
    const zoomLeftBtn = document.querySelector('.zoom-left');
    const zoomRightBtn = document.querySelector('.zoom-right');
    if (zoomLeftBtn && zoomRightBtn) {
      zoomLeftBtn.addEventListener('click', () => this.resetTransform());
      zoomRightBtn.addEventListener('click', () => this.resetTransform());
    }

    zoomPlusBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        if (this.zoomRatio < this.maxZoomRatio) {
          this.zoomRatio += 2;
          this.updateZoom();
          if (this.zoomRatio >= this.maxZoomRatio) this.disableButton(btn);
        }
      });
    });

    zoomMinusBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        if (this.zoomRatio > 1) {
          this.zoomRatio -= 2;
          this.updateZoom();
          if (this.zoomRatio < this.maxZoomRatio) this.enableButton(document.querySelector('.zoom-plus'));
        }
      });
    });
  }

  enableZoomOnTouch() {
    const images = document.querySelectorAll('.image-magnify-hover-mobile');
    images.forEach((image) => {
      image.addEventListener('touchstart', (event) => this.onTouchStart(event));
      image.addEventListener('touchmove', (event) => this.onTouchMove(event));
      image.addEventListener('touchend', (event) => this.onTouchEnd(event));
    });
  }

  onTouchStart(event) {
    if (event.touches.length === 2) {
      // Start pinch gesture
      this.isPinching = true;
      this.initialPinchDistance = this.calculatePinchDistance(event.touches);
      this.lastPinchZoom = this.zoomRatio;
    } else if (event.touches.length === 1 && this.zoomRatio > 1) {
      // Start drag gesture
      this.isDragging = true;
      this.startX = event.touches[0].clientX - this.translateX;
      this.startY = event.touches[0].clientY - this.translateY;
    }
  }

  onTouchMove(event) {
    if (this.isPinching && event.touches.length === 2) {
      const currentPinchDistance = this.calculatePinchDistance(event.touches);
      const pinchZoomFactor = currentPinchDistance / this.initialPinchDistance;
      this.zoomRatio = Math.min(
        Math.max(this.lastPinchZoom * pinchZoomFactor, 1),
        this.maxZoomRatio
      );
      this.updateZoom();
    } else if (this.isDragging && event.touches.length === 1) {
      const touch = event.touches[0];
      this.translateX = touch.clientX - this.startX;
      this.translateY = touch.clientY - this.startY;

      const maxTranslateX = ((this.zoomRatio - 1) * this.activeImage.offsetWidth) / 2;
      const maxTranslateY = ((this.zoomRatio - 1) * this.activeImage.offsetHeight) / 2;

      this.translateX = Math.max(Math.min(this.translateX, maxTranslateX), -maxTranslateX);
      this.translateY = Math.max(Math.min(this.translateY, maxTranslateY), -maxTranslateY);

      this.activeImage.style.transform = `scale(${this.zoomRatio}) translate3d(${this.translateX}px, ${this.translateY}px, 0px)`;
      this.activeImage.style.transition = 'none';
    }
  }

  onTouchEnd(event) {
    if (event.touches.length < 2) {
      this.isPinching = false;
    }
    if (event.touches.length === 0) {
      this.isDragging = false;
    }
  }

  calculatePinchDistance(touches) {
    const [touch1, touch2] = touches;
    const dx = touch2.clientX - touch1.clientX;
    const dy = touch2.clientY - touch1.clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }

  updateZoom() {
    const activeImage = document.querySelector('.swiper-slide-active .image-magnify-hover-mobile');
    if (activeImage) {
      this.activeImage = activeImage;
      this.activeImage.style.transform = `scale(${this.zoomRatio}) translate3d(${this.translateX}px, ${this.translateY}px, 0px)`;
      this.activeImage.style.transformOrigin = 'center center';
      this.activeImage.style.transition = 'transform 0.3s ease';

       // Update zoom buttons based on current zoom ratio
    const zoomPlusBtn = document.querySelector('.zoom-plus');
    const zoomMinusBtn = document.querySelector('.zoom-minus');

    if (this.zoomRatio >= this.maxZoomRatio) {
      this.disableButton(zoomPlusBtn);
    } else {
      this.enableButton(zoomPlusBtn);
    }

    if (this.zoomRatio <= 1) {
      this.disableButton(zoomMinusBtn);
    } else {
      this.enableButton(zoomMinusBtn);
    }
    }
  }

  resetTransform() {
    if (this.activeImage) {
      this.translateX = 0;
      this.translateY = 0;
      this.zoomRatio = 1;
      this.activeImage.style.transform = `scale(1) translate3d(0px, 0px, 0px)`;

      const zoomPlusBtn = document.querySelector('.zoom-plus');
      const zoomMinusBtn = document.querySelector('.zoom-minus');
      this.enableButton(zoomPlusBtn);
      this.enableButton(zoomMinusBtn);
    }
  }

  disableButton(button) {
    if (button) {
      button.disabled = true;
      button.classList.add('disabled');
    }
  }

  enableButton(button) {
    if (button) {
      button.disabled = false;
      button.classList.remove('disabled');
    }
  }
}

if (window.innerWidth < 768) {
  new magnifyJS();
}
class TemplateProductJS {
  constructor() {
    this.init_zoom();

    
  }
  init_zoom() {
    var selectors = {
      productContainer: document.querySelector('.product-details-wrapper'),
      productMedia: document.querySelector('[data-productMedia]'),
      zoomBtns: document.querySelectorAll('[data-productZoom]')
    };
    if (selectors?.productMedia) {
      const mediaJSON = JSON.parse(selectors.productMedia.innerHTML);
      window.productMedia = mediaJSON;
      // Collect all visible `alt` texts from `data-productZoom` images
      const visibleAlts = Array.from(document.querySelectorAll('[data-productZoom] img'))
        .map(img => img.getAttribute('alt'))
        .filter(Boolean); // Remove null or undefined values
      
      // Filter `mediaJSON` for matching alt texts
      window.productMedia = mediaJSON.filter(media => visibleAlts.includes(media.alt));
      if (window.innerWidth < 768) {
        selectors.zoomBtns.forEach((btn) => {
          
          btn.addEventListener('click', (event) => {
            let currentTarget = event.target;
  
            this.manageZoom(currentTarget);
            typeof magnifyJS !== 'undefined' && new magnifyJS();
          });
        });
  
        
      }
    }
  }

  manageZoom(currentTarget){
    let currentSlide = currentTarget?.closest('.product--media');
    let currentSlideIndex = 1;
    if(currentSlide) currentSlideIndex = Array.from(currentSlide.parentNode.children).indexOf(currentSlide);
    
    let zoomSlider = '';
    let zoomThumbSlider = '';
      

    window.productMedia.forEach(i => {
        if(i.media_type == "external_video"){
            zoomSlider += `<div class="swiper-slide carousel-cell d-flex align-items-center justify-content-center zoom--product-image" data-mediaID="${i.id}" role="treeitem">
                <div class="custom-video-container">
                    <custom-video class="placement--grid" data-video-type="${i.host}" data-video-id="${i.external_id}" data-placement="grid" data-autoplay="true" data-controls="true">
                        <div class="cta-btn" data-aos="hero">
                            <button class="play__button btn btn-primary" data-trigger-video aria-label="Play Video">
                                <span class="icon-play text-body"></span>
                            </button>
                            <button class="pause__button btn btn-primary" data-pause-video aria-label="Pause Video">
                                <span class="icon-pause"></span>
                            </button>
                        </div>
                        <div class="content-section">
                            <div class="poster-image">
                                <img class="img-fluid image-magnify-hover--mobile"
                                src="${i.preview_image.src}"
                                alt="${i.alt}"/>
                            </div>
                        </div>
                        <div class="video-section" tabindex="0"></div>
                    </custom-video>
                </div>
            </div>`;
        }else if(i.media_type == "video"){
            zoomSlider += `<div class="swiper-slide carousel-cell d-flex align-items-center product--media" data-mediaID="${i.id}" role="treeitem">
                <div class="custom-video-container pdp_zoom">
                    <custom-video class="placement--grid" data-video-type="local" data-video-id="${i.sources[0].url}" data-placement="grid" data-autoplay="true" data-controls="true">
                        <div class="cta-btn">
                        <button class="play--button p-0 rounded-circle btn btn-primary" data-trigger-video="" aria-label="Play Video">
                        <svg aria-hidden="true" focusable="false" style="width:30px;height:30px;" class="currentColor">
                            <use href="#icon-play"></use>
                        </svg>
                    </button>
                        </div>
                        <div class="content-section">
                            <div class="poster-image">
                                <img class="img-fluid"
                                src="${i.preview_image.src}"
                                alt="${i.alt}"/>
                            </div>
                        </div>
                        <div class="video-section" tabindex="0"></div>
                    </custom-video>
                </div> 
            </div>`;
        }else if(i.media_type == "image"){
            zoomSlider+= `<div class="swiper-slide no-swiping carousel-cell d-flex align-items-center justify-content-center zoom--product-image overflow-hidden " data-mediaID="${i.id}" role="treeitem">
                <img class="img-fluid image-magnify-hover-mobile "
                src="${i.preview_image.src}"
                alt="${i.alt}"/>
            </div>`;
            zoomThumbSlider+= `<div class="swiper-slide carousel-cell d-flex align-items-center justify-content-center product-thumb--image product-zoom-thumb swiper-slide-active" data-mediaID="${i.id}" role="treeitem">
                <img class="img-fluid w-auto"
                src="${i.preview_image.src}&width=100"
                alt="${i.alt}"/> 
            </div>`;
        }
    });
    let finalHTML = `<slider-element class="swiper-container carousel d-block h-100 pb-md-4 pb-0">
        <div class="swiper swiper-slider zoom--product-images h-100" data-nav="product-thumb"
            data-slider='{
                    "loop": false,
                    "observer": true,
                    "observeParents": true,
                    "slidesPerView": "1",
                    "noSwiping": true,
                    "noSwipingClass": "no-swiping",
                    "spaceBetween": 15,
                    "navigation": {
                        "nextEl": ".icon-arrow-right",
                        "prevEl": ".icon-arrow-left"
                    }
                }' role="tree">
            <div class="swiper-wrapper" >${zoomSlider}</div>

            <div class="swiper-button-prev icon-arrow-left zoom-left">
            <svg aria-hidden="true" class="transition svg currentColor position-relative" focusable="false" style="width:18px;height:14px;">
                                    <use href="#icon-previous"></use>
                                  </svg>
                                  </div>
            <div class="swiper-button-next icon-arrow-right zoom-right">
            <svg aria-hidden="true" class="transition svg currentColor position-relative" focusable="false" style="width:18px;height:14px;">
                                    <use href="#icon-next"></use>
                                  </svg></div>
                                  <div class="zoom-controls text-end">
                                  <div class="mb-2"><button class="zoom-plus zoom_btn p-0"><svg aria-hidden="true" focusable="false" style="width:16px;height:16px;">
                                  <use href="#icon-plus"></use>
                                </svg></button></div>
                                  <div><button class="zoom-minus zoom_btn p-0"> <svg aria-hidden="true" focusable="false" style="width:16px;height:16px;">
                                  <use href="#icon-minus"></use>
                                </svg></button></div>
                                </div>
        </div>
        
    </slider-element>
    <div class="swiper-container d-none " data-thumbSlider data-direction="horizontal">
                          <div class="swiper swiper-slider product-thumb zooming_product_thumb" product_thumb data-slider='{
                                  "direction":"horizontal",
                                  "loop": false,
                                  "slidesPerView": "auto",
                                  "spaceBetween": 10,
                                  "noSwiping": true,
                                  "noSwipingClass": "no-swiping",
                                  "grabCursor": true,
                                  "slideToClickedSlide": true,
                                  "navigation": {
                                    "nextEl": ".icon-arrow-right",
                                    "prevEl": ".icon-arrow-left"
                                }
                              }' role="tree">
                              <div class="swiper-wrapper">
                              ${zoomThumbSlider}
                              </div>
                              <div class="swiper-button-prev icon-arrow-left d-none d-md-block"></div>
                              <div class="swiper-button-next icon-arrow-right d-none d-md-block"></div>
                          </div>
                      </div>`;

    const zoomContainer = document.getElementById('PopupModal-zoom');
    console.log(zoomContainer,"zoomContainer")
    if(zoomContainer){
        zoomContainer.querySelector('.modal-body').innerHTML = finalHTML;
        zoomContainer.show();
        window.dispatchEvent(new Event('resize'));
        if(productZoomSlider) productZoomSlider.slideTo(currentSlideIndex, 2000, true);
        const images = document.querySelectorAll('.product-thumb img');

            // Loop through each image
            const divElements = document.querySelectorAll('.product-thumb .product-zoom-thumb');

            // Loop through each div element
            
            for (let i = 0; i < images.length; i++) {
            const altText = images[i].getAttribute('alt');
            
            // Check if alt text contains the word "youtube"
            if (altText && altText.toLowerCase().includes('youtube') || altText.toLowerCase().includes('youtu.be') || altText.toLowerCase().includes('vimeo')) {
                // Remove the image element from its parent
                images[i].parentNode.removeChild(images[i]);

                divElements.forEach(div => {
                    // Check if the div has no innerHTML content
                    if (!div.innerHTML.trim()) {
                      // Remove the empty div element
                      div.parentNode.removeChild(div);
                    }
                  });
            }
            }
    }
  }
}

typeof TemplateProductJS !== 'undefined' && new TemplateProductJS();
